'use strict';

const ValueProposition = {
  init: ({ touchRequest }, done) => {
    const valuePropositions = document
      .getElementById('value-proposition')
      .getElementsByClassName('value-proposition-item');
    Array.from(valuePropositions).forEach(valueProposition => {
      const learnMoreButton = valueProposition.getElementsByClassName(
        'learn-more-button'
      )[0];
      if (!learnMoreButton) return;
      learnMoreButton.addEventListener('click', () => {
        const explanationSection = valueProposition.getElementsByClassName(
          'value-proposition-explanation'
        )[0];
        if (explanationSection.classList.contains('expanded')) {
          explanationSection.classList.remove('expanded');
        } else {
          explanationSection.classList.add('expanded');
          if (touchRequest) {
            explanationSection.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            });
          }
        }
      });
    });
    done();
  },
};

module.exports = ValueProposition;
